<template>
  <section id="users">
      <main style="text-align:left;white-space:normal">
          <div class="title">
            <icon icoClass='title-ico' selected='users'/>
            {{ $t('users') }}
            <a href="/user" class="btn-blue btn-small" v-if="canAdd">{{ $t("add_user") }}</a>
          </div>
          <load-screen :notFullScreen="true" v-show="loadingList"></load-screen>
          <table v-show="!loadingList" class="custom-table">
            <thead>
              <th>{{ $t('username') }}</th>
              <th>{{ $t('name') }}</th>
              <th>{{ $t('lastname') }}</th>
              <th v-if="canEdit || canAdd">{{ $t('actions') }}</th>
            </thead>
            <tbody>
              <tr v-for="(user, index) in objects" :key="index">
                <td>
                    {{ user.user.username }}
                </td>
                <td>
                    {{ user.user.first_name }}
                </td>
                <td>
                    {{ user.user.last_name }}
                </td>
                <td>
                  <router-link :to="'/user/' + user.user.id" :title="$t('detail')" v-if="canEdit">
                    <misc-icon icoClass='title-ico' selected='edit'/>
                  </router-link>
                  <a :title="$t('delete')"  v-if="canAdd" @click="line=user; showDelete=true">
                    <misc-icon icoClass='title-ico' selected='delete' :title="$t('delete')"/>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div id="pages">
            <div class="move-page" @click="page > 1 ? fillPage(page-1) : ''">
              «{{ $t('prev') }}.
            </div>
            <div v-for="pageShown in pagesShown" :key="pageShown" :class="page===pageShown? 'selected-page': 'page'" @click="fillPage(pageShown)">
              {{ pageShown }}
            </div>
            <div class="move-page" @click="page < count/pageSize ? fillPage(page+1) : ''">
              {{ $t('next') }}.»
            </div>
          </div>
          <modal v-show="showDelete">
            <div slot="body" class="delete-modal">
              {{ $t('delete_message') }}
              <div class="buttons">
                <button class="btn-green" @click="deleteLine(line)">{{ $t('ok') }}</button>
                <button class="btn-black" @click="showDelete=false; line=undefined">{{ $t('cancel') }}</button>
              </div>
            </div>
          </modal>
      </main>
    </section>
</template>

<script>
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import icon from './../svg/tabs'
import miscIcon from './../svg/misc'
import {mapActions, mapState} from 'vuex'
import LoadScreen from './../components/LoadScreen'
import Modal from './../components/Modal'
export default {
  name: 'users',
  components: {icon, miscIcon, LoadScreen, Modal},
  props: {
  },
  mixins: [PaginatedFilteredListMixin],
  created () {
    this.$emit('loading')
  },
  mounted () {
    const promises = [
      this.fillPage(this.page),
      this.checkPermissions(['addExp']).then((response) => { this.canAdd = response })
    ]
    Promise.all(promises).then(data => {
      this.$emit('loaded')
    })
  },
  data () {
    return {
      objects: [],
      line: undefined,
      showDelete: false,
      loadingTable: false,
      pageSize: 10,
      clients: [],
      clientsMap: new Map(),
      filters: {},
      showStatus: false,
      canAdd: true,
      canEdit: true,
      canSeeFilters: false,
      tableOrder: 'default'
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,

      user: state => state.auth.user,
      count: state => state.lines.count
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) {
            pages.push(this.page - index)
          }
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) {
            pages.push(this.page + index)
          }
        }
        return pages.sort(function (a, b) { return a - b })
      }
    }
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions',
      deleteUser: 'user/delete',
      getObjects: 'user/list'
    }),
    deleteLine (user) {
      this.deleteUser(user.user.id).then(() => {
        this.fillPage(this.page)
        this.showDelete = false
      })
    },
    fillPage (page) {
      this.filters = {page: page, page_size: this.pageSize}
      this.getPage(page)
    }
  }
}
</script>

<style scoped lang="scss">
#expeditions {
  display: table;
}
#status-box {
  position: absolute;
  top: 4em;
  left: 0;
  background: white;
  width: 100%;
  border: 1px solid #E1E1E1;
  box-sizing: border-box;
  z-index: 999;
  padding: .3em;
}
a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageUsers.vue